import { ShipmentActivity } from './+state/shipment-activities.models';
import { Observable } from 'rxjs';
import { common } from '@qwyk/models';

export abstract class ShipmentActivitiesServiceBase {
    public abstract getShipmentActivities(
        shipmentId: string,
        page: number
    ): Observable<common.PaginatedResponse<ShipmentActivity>>;

    public abstract createComment(
        shipmentId: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload: any
    ): Observable<ShipmentActivity>;
}
